import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';

export function Loader() {
  return (
    <div className="flex flex-col items-center justify-center gap-1 self-stretch py-2">
      <Loader2 className="text-fx-neutral-600 h-5 w-5 animate-spin" />
      <Typography variant="subtitle1" className="!text-fx-neutral-600">
        <FormattedMessage
          defaultMessage="Fetching configuration..."
          description="Add contract sheet: loading state while channel details API runs"
        />
      </Typography>
    </div>
  );
}
